import React from 'react';
import {
	Card, Row, Col, Button, Tag, Spin, Tooltip, Empty, Alert, Collapse,
	Typography, Table, Tabs, Modal, Input, message,
} from 'antd';
import {
	ExclamationCircleOutlined, CheckCircleOutlined, RedoOutlined,
	SafetyCertificateOutlined, WarningOutlined, StopOutlined, UndoOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, setConfig, extractResult } from '../../store/actions';
import { Helmet } from 'react-helmet';
import Config from '../../Config';

const { Text } = Typography;
const { Panel } = Collapse;
const { TabPane } = Tabs;
const { TextArea } = Input;

// Laporan audit - lihat diskusi 2026-10-09. Nopol yang punya >1 baris
// Kendaraan AKTIF dengan identitas (rangka+mesin) BERBEDA - kemungkinan
// data nyasar (termasuk yang ditemukan dari bug normalisasi whitespace di
// command migrasi massal kendaraan).
const configClass = {
	title: 'Laporan Duplikat Nopol Aktif',
	apiUrl: {
		duplikat: 'laporan/api/duplikat-nopol-aktif/',
		riwayat: 'laporan/api/duplikat-nopol-aktif/riwayat/',
		nonaktifkan: 'laporan/api/duplikat-nopol-aktif/nonaktifkan/',
		aktifkanKembali: 'laporan/api/duplikat-nopol-aktif/aktifkan-kembali/',
	},
	breadCrumb: ['Laporan', 'Duplikat Nopol Aktif'],
};

const config = new Config();

class LapDuplikatNopolAktif extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isMobile: window.innerWidth <= 768,
			activeTab: 'duplikat',

			loadingDuplikat: false,
			duplikatList: [],

			loadingRiwayat: false,
			riwayatList: [],

			modalAksi: null, // { mode: 'nonaktifkan' | 'aktifkan', kendaraan }
			alasan: '',
			loadingAksi: false,
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
		this.fetchDuplikat();
		this.fetchRiwayat();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	fetchDuplikat = () => {
		this.setState({ loadingDuplikat: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.duplikat)
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					// Backend balas {'results': [...]} TANPA field 'count' -
					// extractResult() meng-unwrap langsung jadi array (lihat
					// store/actions.js baris ~251), BUKAN objek {results:[...]}.
					// responseMsg di sini SUDAH berupa array itu sendiri.
					this.setState({ duplikatList: Array.isArray(responseMsg) ? responseMsg : [] });
				}
				this.setState({ loadingDuplikat: false });
			}).catch(() => this.setState({ loadingDuplikat: false }));
	};

	fetchRiwayat = () => {
		this.setState({ loadingRiwayat: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.riwayat)
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					// Sama seperti fetchDuplikat - responseMsg sudah array.
					this.setState({ riwayatList: Array.isArray(responseMsg) ? responseMsg : [] });
				}
				this.setState({ loadingRiwayat: false });
			}).catch(() => this.setState({ loadingRiwayat: false }));
	};

	openModalNonaktifkan = (baris) => {
		this.setState({ modalAksi: { mode: 'nonaktifkan', kendaraan: baris }, alasan: '' });
	};

	openModalAktifkan = (baris) => {
		this.setState({ modalAksi: { mode: 'aktifkan', kendaraan: baris }, alasan: '' });
	};

	closeModal = () => {
		if (this.state.loadingAksi) return;
		this.setState({ modalAksi: null, alasan: '' });
	};

	submitAksi = () => {
		const { modalAksi, alasan } = this.state;
		if (!modalAksi) return;
		const alasanTrim = alasan.trim();
		if (!alasanTrim) {
			message.error({ content: 'Alasan wajib diisi', duration: 2, key: 'toast' });
			return;
		}

		const isNonaktifkan = modalAksi.mode === 'nonaktifkan';
		const url = isNonaktifkan ? configClass.apiUrl.nonaktifkan : configClass.apiUrl.aktifkanKembali;

		this.setState({ loadingAksi: true });
		this.props.ajaxViewHandler('post', url, {
			kendaraan_id: modalAksi.kendaraan.kendaraan_id,
			alasan: alasanTrim,
		}).then((action) => {
			const { isSuccess, responseMsg } = extractResult(action);
			this.setState({ loadingAksi: false });
			if (isSuccess) {
				message.success({
					content: (responseMsg && responseMsg.status) || 'Berhasil',
					duration: 3, key: 'toast',
				});
				this.setState({ modalAksi: null, alasan: '' });
				this.fetchDuplikat();
				this.fetchRiwayat();
			} else {
				message.error({
					content: (responseMsg && responseMsg.error) || 'Gagal memproses, coba lagi',
					duration: 4, key: 'toast',
				});
			}
		}).catch(() => {
			this.setState({ loadingAksi: false });
			message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
		});
	};

	_renderRingkasanCards() {
		const { duplikatList, riwayatList } = this.state;
		const totalBaris = duplikatList.reduce((acc, g) => acc + g.baris.length, 0);
		const cards = [
			{ label: 'Nomor Polisi Terdeteksi Duplikat', value: duplikatList.length, color: '#cf1322', icon: <WarningOutlined /> },
			{ label: 'Total Baris Kendaraan Terlibat', value: totalBaris, color: '#0f2847', icon: <SafetyCertificateOutlined /> },
			{ label: 'Sudah Dinonaktifkan Lewat Menu Ini', value: riwayatList.length, color: '#389e0d', icon: <CheckCircleOutlined /> },
		];
		return (
			<Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
				{cards.map((c) => (
					<Col key={c.label} xs={24} sm={8}>
						<Card style={{ borderRadius: 14, border: 'none', boxShadow: '0 4px 20px rgba(15,40,71,0.08)' }} bodyStyle={{ padding: 20 }}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
								<div style={{
									width: 48, height: 48, borderRadius: 12, flexShrink: 0,
									background: `${c.color}14`, color: c.color,
									display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22,
								}}>
									{c.icon}
								</div>
								<div>
									<div style={{ fontSize: 26, fontWeight: 800, color: c.color, lineHeight: 1 }}>{c.value}</div>
									<div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>{c.label}</div>
								</div>
							</div>
						</Card>
					</Col>
				))}
			</Row>
		);
	}

	_renderGroupHeader(g) {
		return (
			<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, width: '100%' }}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
					<span style={{ fontFamily: 'monospace', fontWeight: 800, fontSize: 15, color: '#0f2847' }}>{g.nomor_polisi}</span>
					<Tag
						icon={<WarningOutlined />}
						style={{ borderRadius: 20, fontWeight: 600, margin: 0, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322' }}
					>
						{g.baris.length} baris aktif, identitas berbeda
					</Tag>
				</div>
			</div>
		);
	}

	_renderGroupTable(g) {
		const columns = [
			{ title: 'No. Rangka', dataIndex: 'nomor_rangka', key: 'nomor_rangka', render: (v) => <Text style={{ fontFamily: 'monospace' }}>{v}</Text> },
			{ title: 'No. Mesin', dataIndex: 'nomor_mesin', key: 'nomor_mesin', render: (v) => <Text style={{ fontFamily: 'monospace' }}>{v}</Text> },
			{ title: 'Pemilik', dataIndex: 'pemilik_nama', key: 'pemilik_nama' },
			{ title: 'Kabupaten', dataIndex: 'kabupaten', key: 'kabupaten' },
			{ title: 'Terakhir Update', dataIndex: 'update_at', key: 'update_at', width: 160,
				render: (v) => v ? new Date(v).toLocaleString('id-ID') : '-' },
			{ title: 'Jml Transaksi', dataIndex: 'jumlah_transaksi', key: 'jumlah_transaksi', width: 110, align: 'center' },
			{ title: 'Aksi', key: 'aksi', width: 130, align: 'center',
				render: (_, row) => (
					<Button danger size="small" icon={<StopOutlined />} onClick={() => this.openModalNonaktifkan(row)}>
						Nonaktifkan
					</Button>
				) },
		];
		return (
			<Table
				size="small"
				pagination={false}
				rowKey="kendaraan_id"
				dataSource={g.baris}
				columns={columns}
				scroll={{ x: true }}
			/>
		);
	}

	_renderTabDuplikat() {
		const { loadingDuplikat, duplikatList } = this.state;
		if (loadingDuplikat && duplikatList.length === 0) {
			return <div style={{ textAlign: 'center', padding: 48 }}><Spin size="large" /></div>;
		}
		if (duplikatList.length === 0) {
			return <Empty description="Tidak ada nomor polisi duplikat aktif terdeteksi" />;
		}
		return (
			<Collapse bordered={false}>
				{duplikatList.map((g) => (
					<Panel
						key={g.nomor_polisi}
						style={{ marginBottom: 8, borderRadius: 10, overflow: 'hidden', border: '1px solid #ffccc7' }}
						header={this._renderGroupHeader(g)}
					>
						{this._renderGroupTable(g)}
					</Panel>
				))}
			</Collapse>
		);
	}

	_renderTabRiwayat() {
		const { loadingRiwayat, riwayatList, isMobile } = this.state;
		if (loadingRiwayat && riwayatList.length === 0) {
			return <div style={{ textAlign: 'center', padding: 48 }}><Spin size="large" /></div>;
		}
		if (riwayatList.length === 0) {
			return <Empty description="Belum ada kendaraan yang dinonaktifkan lewat menu ini" />;
		}
		const columns = [
			{ title: 'Nopol', dataIndex: 'nomor_polisi', key: 'nomor_polisi', render: (v) => <Text style={{ fontFamily: 'monospace', fontWeight: 700 }}>{v}</Text> },
			{ title: 'No. Rangka', dataIndex: 'nomor_rangka', key: 'nomor_rangka' },
			{ title: 'No. Mesin', dataIndex: 'nomor_mesin', key: 'nomor_mesin' },
			{ title: 'Pemilik', dataIndex: 'pemilik_nama', key: 'pemilik_nama' },
			{ title: 'Dinonaktifkan Oleh', dataIndex: 'dinonaktifkan_oleh', key: 'dinonaktifkan_oleh' },
			{ title: 'Tanggal', dataIndex: 'tanggal_deleted', key: 'tanggal_deleted', width: 160,
				render: (v) => v ? new Date(v).toLocaleString('id-ID') : '-' },
			{ title: 'Alasan', dataIndex: 'alasan_deleted', key: 'alasan_deleted', ellipsis: true },
			{ title: 'Aksi', key: 'aksi', width: 150, align: 'center',
				render: (_, row) => (
					<Button type="primary" size="small" icon={<UndoOutlined />} onClick={() => this.openModalAktifkan(row)}>
						Aktifkan Kembali
					</Button>
				) },
		];
		return (
			<Table
				size="small"
				pagination={{ pageSize: 10 }}
				rowKey="kendaraan_id"
				dataSource={riwayatList}
				columns={columns}
				scroll={{ x: true }}
			/>
		);
	}

	_renderModalAksi() {
		const { modalAksi, alasan, loadingAksi, isMobile } = this.state;
		if (!modalAksi) return null;
		const isNonaktifkan = modalAksi.mode === 'nonaktifkan';
		const k = modalAksi.kendaraan;
		return (
			<Modal
				title={isNonaktifkan ? 'Nonaktifkan Kendaraan Duplikat' : 'Aktifkan Kembali Kendaraan'}
				visible={true}
				onCancel={this.closeModal}
				closable={!loadingAksi}
				maskClosable={false}
				width={isMobile ? '94%' : 480}
				footer={[
					<Button key="batal" onClick={this.closeModal} disabled={loadingAksi}>Batal</Button>,
					<Button
						key="submit"
						type={isNonaktifkan ? 'primary' : 'primary'}
						danger={isNonaktifkan}
						loading={loadingAksi}
						onClick={this.submitAksi}
					>
						{isNonaktifkan ? 'Nonaktifkan' : 'Aktifkan Kembali'}
					</Button>,
				]}
			>
				<Alert
					type={isNonaktifkan ? 'warning' : 'info'}
					showIcon
					style={{ marginBottom: 16 }}
					message={isNonaktifkan
						? 'Kendaraan ini akan ditandai tidak aktif (soft-delete). Bisa diaktifkan kembali lewat tab "Riwayat Dinonaktifkan" kalau keliru.'
						: 'Kendaraan ini akan diaktifkan kembali dan muncul lagi di pencarian normal.'}
				/>
				<div style={{ marginBottom: 12, fontSize: 13, color: '#595959' }}>
					<div><b>Nopol:</b> {k.nomor_polisi}</div>
					<div><b>No. Rangka:</b> {k.nomor_rangka}</div>
					<div><b>No. Mesin:</b> {k.nomor_mesin}</div>
					<div><b>Pemilik:</b> {k.pemilik_nama || '-'}</div>
				</div>
				<div style={{ marginBottom: 6, fontWeight: 600, fontSize: 13 }}>Alasan <span style={{ color: '#cf1322' }}>*</span></div>
				<TextArea
					rows={3}
					value={alasan}
					onChange={(e) => this.setState({ alasan: e.target.value })}
					placeholder={isNonaktifkan ? 'Mis. data duplikat hasil migrasi, bukan kendaraan aktif.' : 'Mis. ternyata keliru, baris ini yang benar.'}
					disabled={loadingAksi}
				/>
			</Modal>
		);
	}

	render() {
		const { isMobile, activeTab } = this.state;
		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
				</Helmet>

				<Card style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden', marginBottom: 16 }} bodyStyle={{ padding: 0 }}>
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
							<SafetyCertificateOutlined style={{ marginRight: 8 }} />
							{configClass.title}
						</div>
						<Tooltip title="Refresh data">
							<Button icon={<RedoOutlined />} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								onClick={() => { this.fetchDuplikat(); this.fetchRiwayat(); }}
								loading={this.state.loadingDuplikat || this.state.loadingRiwayat}>
								{!isMobile && 'Refresh'}
							</Button>
						</Tooltip>
					</div>
					<div style={{ padding: 20 }}>
						<Alert
							type="info"
							showIcon
							style={{ marginBottom: 16 }}
							message="Kegunaan laporan ini"
							description="Menunjukkan nomor polisi yang punya lebih dari satu baris kendaraan AKTIF dengan nomor rangka/mesin yang BERBEDA - kemungkinan data nyasar (misal akibat migrasi data). Tinjau tiap baris (terutama jumlah transaksinya) sebelum menonaktifkan salah satu."
						/>
						{this._renderRingkasanCards()}
						<Tabs activeKey={activeTab} onChange={(k) => this.setState({ activeTab: k })}>
							<TabPane tab={`Duplikat Aktif (${this.state.duplikatList.length})`} key="duplikat">
								{this._renderTabDuplikat()}
							</TabPane>
							<TabPane tab={`Riwayat Dinonaktifkan (${this.state.riwayatList.length})`} key="riwayat">
								{this._renderTabRiwayat()}
							</TabPane>
						</Tabs>
					</div>
				</Card>

				{this._renderModalAksi()}
			</div>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers;
};

export default connect(
	mapStateToProps,
	{ initHandler, setConfig, ajaxViewHandler }
)(LapDuplikatNopolAktif);
